import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://bet-partners.com';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

export default function Seo({ title, description, path = '/', image = DEFAULT_IMAGE, jsonLd }) {
  const url = `${SITE_URL}${path}`;
  const fullTitle = `${title} | BET-Partners`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {jsonLd && (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((schema, index) => (
        <script key={index} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
}
